import auth from './auth';
import payment_methods from './payment_methods';
import ticket from './ticket';
import machine from './machine';

export default {
	auth,
	payment_methods,
	ticket,
	machine
};
